import React from "react";

import RuleAccordion from "./RuleAccordion";

function ArbitrageSectionCard({ section }) {
  return (
    <section className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <div className="grid gap-0 lg:grid-cols-[1fr_0.82fr]">
        <div className="p-4 sm:p-6">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-amber-600 dark:text-amber-200">
            {section.badge}
          </p>

          <h2 className="mt-2 font-titre text-2xl font-bold text-slate-950 dark:text-white sm:text-3xl">
            {section.title}
          </h2>

          {section.subtitle && (
            <p className="mt-3 text-sm font-bold text-slate-700 dark:text-white/80">
              {section.subtitle}
            </p>
          )}

          {section.description && (
            <p className="mt-3 text-sm font-medium leading-7 text-slate-600 dark:text-white/60">
              {section.description}
            </p>
          )}

          {section.bullets?.length > 0 && (
            <ul className="mt-5 space-y-2">
              {section.bullets.map((bullet, index) => (
                <li
                  key={`${section.id}-bullet-${index}`}
                  className="flex gap-2 text-sm font-medium leading-6 text-slate-600 dark:text-white/60"
                >
                  <span className="mt-1 text-amber-500">●</span>
                  <span>{bullet}</span>
                </li>
              ))}
            </ul>
          )}

          {section.rules?.length > 0 && (
            <div className="mt-5 space-y-3">
              {section.rules.map((rule) => (
                <RuleAccordion key={rule.id} rule={rule} />
              ))}
            </div>
          )}
        </div>

        {section.image && (
          <div className="bg-slate-100 p-4 dark:bg-slate-950 sm:p-6">
            <div className="overflow-hidden rounded-[2rem] bg-white shadow-xl dark:bg-white/[0.03]">
              <img
                src={section.image}
                alt={section.title}
                className="h-full min-h-[280px] w-full object-cover"
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default ArbitrageSectionCard;